// extracted by mini-css-extract-plugin
export default {"spinner":"spinner_spinner__h74PT","preloader":"spinner_preloader__tjaEy","loader":"spinner_loader__Qq-DP","spin":"spinner_spin__w4888"};